module.exports = __webpack_public_path__ + "static/media/facebook.01a6394e.svg";